import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { notification } from "antd";
import * as uploadActions from "../../store/actions/documents/upload";
import { getRealMimeTypeFromSignatureFile, openNotificationWithIcon, getListAcceptedDocument } from "../../libs/utils";
import { FormattedMessage, useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DropZone from "./dropZone";
import FileBlock from "./fileBlock";
import FooterButtons from "./footerButtons";
import OptionalData from "./optionalData";
import MessageNotification from "./messageNotification";

import "./style.css";

const Uploader = ({ accountantIdSelected, clientIdSelected, isFoldersEdit, myType, newDeadline, uploadDocAction, setDocumentsAdded }) => {
  const dispatch = useDispatch();

  const intl = useIntl();

  const location = useLocation();
  const navigate = useNavigate();
  /** REDUX */
  const companies = useSelector((state) => state.company.companies);
  const currentPermissions = useSelector((state) => state.currentPermissions);
  const infoUpload = useSelector((state) => state.documents.upload);

  /** STATE COMPONENT */
  const [filesListInfo, setFilesListInfo] = useState([]);
  const [filesToUpload, setFilesToUpload] = useState([]);
  const [isSendButton, setIsSendButton] = useState(false);
  // i totali servono nella notification finale
  const [total, setTotal] = useState({ success: 0, errors: 0 });
  const [category, setCategory] = useState(0);
  const [isEncrypted, setIsEncrypted] = useState(false);
  const [accountable, setAccountable] = useState(false);
  const [isHide, setIsHide] = useState(false);
  const [isResetUpload, setIsResetUpload] = useState(false);
  const [note, setNote] = useState(null);
  const [metadata, setMetadata] = useState([
    {
      name: "periodo",
      value: null,
      correctedValue: null,
    },
    {
      name: "documento.tipo",
      value: null,
      correctedValue: null,
    },
  ]);

  const listAcceptedDocuments = getListAcceptedDocument(currentPermissions, location);
  const extensions = Array.from(
    new Set(
      listAcceptedDocuments.map((item) => {
        return item.ext.toUpperCase();
      })
    )
  );

  useEffect(() => {
    if (!isResetUpload) return undefined;
    dispatch(uploadActions.resetUploadDocument());
    setIsEncrypted(false);
    setIsHide(false);
    setIsSendButton(false);
    setTotal({ errors: 0, success: 0 });
    setFilesListInfo([]);
    setFilesToUpload([]);
    setIsResetUpload(false);
    setAccountable(false);
    notification.destroy(); // chiudo tutte le eventuali notifiche aperte

    return () => {
      // in unmount distruggo la notifica e resetto l'upload in redux
      notification.destroy();
      setTotal({ success: 0, errors: 0 });

      dispatch(uploadActions.resetUploadDocument());
    };
  }, [isResetUpload]);

  useEffect(() => {
    if (!isFoldersEdit && !filesToUpload && filesToUpload.length === 0) return;
    // Riguarda caricamento da folders o da deadlines
    isFoldersEdit && filesToUpload && uploadDocAction(filesToUpload);
    if (filesToUpload.length > 0 && setDocumentsAdded) {
      setDocumentsAdded(filesToUpload);
    }
  }, [filesToUpload, isFoldersEdit]);

  useEffect(() => {
    if (!infoUpload.isUploadingSingleDocument) return;
    updateStateObj(infoUpload.isUploadingSingleDocument, false, false, true, null);
  }, [infoUpload.isUploadingSingleDocument]);

  useEffect(() => {
    if (!infoUpload?.uploadedSingleDocument) return;
    updateStateObj(null, true, false, false, "success");

    // controllo che non abbia gia rimosso il file che è stato caricato con successo
    let isFilePresent = filesToUpload.some((el) => el.name === infoUpload.uploadedSingleDocument.fileName);
    if (!isFilePresent) return;

    /* una volta effettuato l'upload cancello il file dal blocco dei da caricare
    let removedFinished = filesListInfo.filter(el => {
      return el.name !== infoUpload.uploadedSingleDocument.fileName;
    });
    */
  }, [infoUpload.uploadedSingleDocument]);

  useEffect(() => {
    if (!infoUpload.errorSingleDocument) return;

    updateStateObj(infoUpload.errorSingleDocument, false, true, true, "errors");
  }, [infoUpload.errorSingleDocument]);

  /*
  useEffect(() => {
    if (!infoUpload.uploadedSingleDocument) return;
    // controllo che non abbia gia rimosso il file che è stato caricato con successo
    let isFilePresent = filesToUpload.some(el => el.name === infoUpload.uploadedSingleDocument.fileName);
    if (!isFilePresent) return;

    // una volta effettuato l'upload cancello il file dal blocco dei da caricare
    let removedFinished = filesListInfo.filter(el => {
      return el.name !== infoUpload.uploadedSingleDocument.fileName;
    });
    return {
      filesListInfo: removedFinished,
      filesToUpload: removedFinished,
      totalSuccess: total.success
    };
  }, [infoUpload.uploadedSingleDocument]);
*/
  /**
   * Funzione per evitare duplicazione in fase aggiornamento stato
   * @param {object} eventObj: il tipo di evento da considerare
   * @param {boolean} isEnded
   * @param {boolean} isError
   * @param {boolean} isStart
   * @param {string} counterToUpdate: la property del contatore da aggiornare(error o success)
   * @returns
   */
  const updateStateObj = (eventObj, isEnded, isError, isStart, counterToUpdate) => {
    if (counterToUpdate) {
      setTotal({ ...total, [counterToUpdate]: total[counterToUpdate] + 1 });
    }

    // se voglio solo aumentare il contatore dei successi eventObj è null
    if (!eventObj) return;
    /** Recuperiamo l'indice in array del file il cui stato deve essere aggiornato */
    const indexUploaded = filesListInfo.map((x) => x.name).indexOf(eventObj.fileName);
    if (indexUploaded < 0) return;

    let updateFilesListInfo = [...filesListInfo];
    updateFilesListInfo[indexUploaded].isUploaded = isEnded;
    updateFilesListInfo[indexUploaded].isErrorUploaded = isError;
    updateFilesListInfo[indexUploaded].errorMessage = eventObj.message ? eventObj.message : null;
    updateFilesListInfo[indexUploaded].isUploading = isStart;
    updateFilesListInfo[indexUploaded].progress = eventObj.progress ? eventObj.progress : null;
  };

  const caricaDocumento = () => {
    setIsSendButton(false);
    const selectedCompany = companies.find((el) => {
      return el.id === clientIdSelected;
    });
    const sender = myType === "STUDIO" ? accountantIdSelected : clientIdSelected;
    const recipient = myType === "STUDIO" ? clientIdSelected : accountantIdSelected;
    dispatch(
      uploadActions.uploadDocuments(
        sender,
        selectedCompany.partitaIva,
        filesToUpload,
        category, // categoria,
        recipient,
        note, // note,
        metadata, // metadata,
        selectedCompany.codiceFiscale,
        "WEB",
        isEncrypted, // da proteggere,
        myType,
        isHide /* visibile solo allo studio*/,
        accountable /** da contabilizzare */
      )
    );
  };

  const handleDrop = (filesList) => {
    const files = filesList.target ? filesList.target.files : filesList;
    setIsSendButton(true);

    // const newFilesListInfo = [];
    let newFilesToUpload = Array.from(filesToUpload);
    let newFilesListInfo = Array.from(filesListInfo);

    let newFiles = [];
    try {
      files.forEach((file) => {
        newFiles.push(file);
      });
    } catch (e) {
      Object.keys(files).forEach((key) => {
        if (key !== "length") {
          newFiles.push(files[key]);
        }
      });
    }

    newFiles.forEach((file) => {
      const filereader = new FileReader();
      let infoFile;
      // let isPreError; // se il file viene bloccato subito devo aggiornare il conteggio errori o in notification ho dei disallineamenti
      filereader.onloadend = (evt) => {
        if (evt.target.readyState === FileReader.DONE) {
          const uint = new Uint8Array(evt.target.result);
          let bytes = [];
          uint.forEach((byte) => {
            bytes.push(byte.toString(16));
          });

          const hex = bytes.join("").toUpperCase();
          let realNatureOfFile = getRealMimeTypeFromSignatureFile(hex);
          const acceptedFile = listAcceptedDocuments.find((el) => el.mime === realNatureOfFile);
          infoFile = {
            name: file.name,
            size: file.size,
          };

          const regularExpExtension = /(?:\.([^.]+))?$/;
          const fileExtensions = regularExpExtension.exec(file.name)[1].toUpperCase();

          if (!acceptedFile || !extensions.includes(fileExtensions)) {
            infoFile.acceptedFile = false;
            // isPreError = true;
          } else {
            infoFile.acceptedFile = true;
            // isPreError = false;
          }
          newFilesListInfo = newFilesListInfo.concat(infoFile);
          newFilesToUpload = infoFile.acceptedFile ? newFilesToUpload.concat(file) : newFilesToUpload;

          setFilesToUpload(newFilesToUpload);
          setFilesListInfo(newFilesListInfo);
        }
      };
      const blob = file.slice(0, 4);
      filereader.readAsArrayBuffer(blob);
    });
  };

  const onRemove = (toRemove) => {
    setIsEncrypted(false);
    setIsHide(false);
    setAccountable(false);
    setFilesListInfo((prevState) => {
      return prevState.filter((el) => {
        return el.name !== toRemove.name;
      });
    });
    setFilesToUpload((prevState) => {
      return prevState.filter((el) => {
        return el.name !== toRemove.name;
      });
    });
  };

  const updateOptionalData = (category, isEncrypted, isHide, metadata, note, isAccountable) => {
    setCategory(category);
    setIsEncrypted(isEncrypted);
    setIsHide(isHide);
    setMetadata(metadata);
    setNote(note);
    setAccountable(isAccountable);
  };

  const renderNotification = () => {
    let messageNotify = "";
    let icon;
    let colorType;
    let notificationType;

    switch (true) {
      case total.errors === 0 && isFoldersEdit: {
        break;
      }
      case filesListInfo.length === total.success && total.errors === 0 && !isFoldersEdit:
        /** Tutti caricati */
        messageNotify = (
          <MessageNotification
            navigate={navigate}
            setIsResetUpload={setIsResetUpload}
            textMessage={intl.formatMessage({ id: "upload.feedback.success" }, { total: total.success.toString() })}
          />
        );
        icon = "check-circle";
        colorType = "#09822a";
        notificationType = "success";
        break;

      case total.success === 0:
        messageNotify =
          infoUpload.errorSingleDocument && infoUpload.errorSingleDocument.status === 401 ? (
            <MessageNotification
              navigate={navigate}
              setIsResetUpload={setIsResetUpload}
              textMessage={useIntl().formatMessage({ id: "upload.feedback.noPermissions" })}
            />
          ) : (
            <MessageNotification
              navigate={navigate}
              setIsResetUpload={setIsResetUpload}
              textMessage={useIntl().formatMessage({ id: "upload.feedback.genericError" })}
            />
          );
        icon = "minus-circle";
        colorType = "#d82829";
        notificationType = "error";
        break;

      default:
        messageNotify = (
          <MessageNotification
            navigate={navigate}
            setIsResetUpload={setIsResetUpload}
            textMessage={`${total.success} ${useIntl().formatMessage({ id: "upload.feedback.successUploaded" })} ${total.errors} ${useIntl().formatMessage({
              id: "upload.feedback.inError",
            })}! ${useIntl().formatMessage({ id: "upload.feedback.goToDocuments" })}`}
          />
        );
        icon = "exclamation-circle";
        colorType = "#fdb927";
        notificationType = "warning";
        break;
    }

    return (
      infoUpload.isUploadFinished &&
      !isFoldersEdit &&
      openNotificationWithIcon(notification, notificationType, "", messageNotify, <FontAwesomeIcon icon={["fas", icon]} style={{ color: colorType }} />, () =>
        setIsResetUpload(true)
      )
    );
  };

  let renderFile = [];

  filesListInfo.forEach((file) => {
    renderFile.push(
      <FileBlock
        key={"fileRow-" + file.name}
        file={file}
        isToEncrypt={isEncrypted}
        isAccountable={accountable}
        isToHide={isHide}
        onRemove={onRemove}
        isFoldersEdit={isFoldersEdit}
      />
    );
  });

  return (
    <div className="contentUploader" style={{ padding: "16px" }}>
      <div style={{ flex: "1", marginTop: "6px" }}>
        <div className="label">
          <div className="titleLabel">
            {isFoldersEdit ? useIntl().formatMessage({ id: "upload.newDocument" }) : useIntl().formatMessage({ id: "upload.orNewDocument" })}
          </div>
        </div>
        <DropZone handleDrop={handleDrop} />
        <div className="descriptionLabel">
          {useIntl().formatMessage({ id: "upload.acceptedFiles" })} {extensions.join(", ")}. {useIntl().formatMessage({ id: "upload.maxSize" })}.
        </div>
        {filesListInfo.length > 0 && !isFoldersEdit && !newDeadline ? (
          <span className="titleList">
            <FormattedMessage id="upload.selectedDocuments" />
          </span>
        ) : null}
        <div
          className="uploaderListFile"
          style={{
            minHeight: newDeadline ? "120px" : isFoldersEdit ? "" : "100%",
            maxWidth: newDeadline ? "430px" : "100%",
          }}
        >
          {renderFile}
        </div>
        {filesToUpload.length > 0 && isSendButton && !isFoldersEdit && !newDeadline && <OptionalData updateOptionalData={updateOptionalData} myType={myType} />}
      </div>
      {filesToUpload.length > 0 && isSendButton && !isFoldersEdit && !newDeadline && (
        <FooterButtons resetUpload={() => setIsResetUpload(true)} saveFiles={caricaDocumento} />
      )}
      {!newDeadline && renderNotification()}
    </div>
  );
};

export default Uploader;
